import { Row, RowSpan } from 'components/checkout/caap/Layout';
import css from 'styles/components/checkout/caap/payment/paymentlist/confirmCardError.scss';

const ConfirmCardError = ({ isChecked, confirmCardMessage, selectedPaymentNeedsConfirmation }) => {
  if (selectedPaymentNeedsConfirmation && isChecked && confirmCardMessage) {
    return (
      <div className={css.confirmCardErrorContainer}>
        <Row>
          <RowSpan span="12">
            <div className={css.warningContainer}>
              <h2 className={css.errorHeading}>There was a problem</h2>
              <p>{confirmCardMessage}</p>
            </div>
          </RowSpan>
        </Row>
      </div>
    );
  }

  return null;
};

export default ConfirmCardError;
